import { c as _c } from "react/compiler-runtime";
import { ResponsiveImage } from '@/components/Atoms/ResponsiveImage/ResponsiveImage';
import cardStyles from '@/components/Molecules/Card/Card.module.css';
import { ContentStatus } from '@/components/Molecules/ContentStatus/ContentStatus';
import type { IAnalyticsTraceableElement, IContentItem } from '@/interfaces';
import { buildTrackingObject } from '@/services/Analytics/bbAnalyticsTrackers';
import { TrackingAction } from '@/services/Analytics/bnefAnalyticsSettings';
import { ResponsiveImageHints } from '@/services/ResponsiveImageHints';
import { ratios } from '@/styles/layout';
import classNames from '@/utils/classNames';
import type { FCl } from 'react-fc';
import styles from './FlagshipCard.module.css';
export const FlagshipCard: FCl<{
  flagship: IContentItem;
} & IAnalyticsTraceableElement> = t0 => {
  const $ = _c(21);
  const {
    flagship,
    analyticsCategory,
    analyticsBaseId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = classNames(cardStyles.card, styles.card);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== analyticsBaseId || $[2] !== analyticsCategory) {
    t2 = buildTrackingObject(TrackingAction.FollowLink, analyticsCategory, analyticsBaseId);
    $[1] = analyticsBaseId;
    $[2] = analyticsCategory;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames(cardStyles.contentsBox, styles.contentsBox);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = new ResponsiveImageHints({
      initial: "100vw",
      atM: "50vw",
      atXL: "25vw"
    }, null, ratios.paperAPortrait);
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== flagship.leadImage || $[7] !== flagship.title) {
    t5 = <ResponsiveImage src={flagship.leadImage} alt={flagship.title} sizeHints={t4} />;
    $[6] = flagship.leadImage;
    $[7] = flagship.title;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== flagship.title || $[10] !== flagship.url || $[11] !== t5) {
    t6 = <a href={flagship.url} className="bbui-card-primary-action" aria-label={flagship.title}>{t5}</a>;
    $[9] = flagship.title;
    $[10] = flagship.url;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== flagship.contentStatus) {
    t7 = <ContentStatus className={styles.badge} status={flagship.contentStatus} />;
    $[13] = flagship.contentStatus;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className={t3}>{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t2 || $[19] !== t8) {
    t9 = <section className={t1} data-analytics-tracking={t2}>{t8}</section>;
    $[18] = t2;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};